export default __webpack_public_path__ + "static/media/datepickericon-purple.60181926.svg";